<div class="inquiries-calendar-meta">
  <div class="inquiries-calendar-navigation">
    <i
      class="fa-solid fa-angles-left pointer"
      [ngClass]="{ disabled: isCustomisedTooltip && isScrollStartPosition }"
      [ngbTooltip]="'tooltip.jumpStart' | translate"
      (click)="navigateCalendar(baseInquiryScrollSliderEnum.start)"
    ></i>
    <div
      [ngbTooltip]="
        (isCustomisedTooltip && isScrollStartPosition
          ? 'inquiry.tooltip.calendarNavigation.minDate'
          : 'tooltip.backwards'
        ) | translate
      "
    >
      <i
        class="fa-solid fa-chevron-left pointer"
        [ngClass]="{ disabled: isCustomisedTooltip && isScrollStartPosition }"
        (click)="navigateCalendar(baseInquiryScrollSliderEnum.left)"
      ></i>
    </div>
    <span class="fw-bold">{{ 'days.calendarWeek' | translate }}</span>
    <i
      class="fa-solid fa-chevron-right pointer"
      [ngbTooltip]="'tooltip.forwards' | translate"
      (click)="navigateCalendar(baseInquiryScrollSliderEnum.right)"
    ></i>
    <i
      class="fa-solid fa-angles-right pointer"
      [ngbTooltip]="'tooltip.jumpEnd' | translate"
      (click)="navigateCalendar(baseInquiryScrollSliderEnum.end)"
    ></i>
  </div>
</div>
